module.exports = __webpack_public_path__ + "static/atws_full_logo-08a56deb22909d3d2fa53c4d5461c9c9.svg";